module.exports = __webpack_public_path__ + "static/media/hall-PD.4767d38e.svg";